import useReactiveZone from "reactive-zone";
import Logger from "../../../core/utils/Logger.js";
import Utils from "../../utils/Common.util.js";
import TaiBaseWidget from "../base.widget.js";
import template from './MultipleText.template.html'


const counterType = {
    character: (value = '') => {
        return value.length;
    },
    word: (value) => {
        return Utils.WordCounter(value);
    }
}
class MultipleTextWidget extends TaiBaseWidget {

    onZoneInit(){
        const { injectPropToZone, injectMethodToZone, useZoneComputed, onZoneChanges } = useReactiveZone(this);
        this.props = injectPropToZone({
            textCounter: `${this.getCounter()} / ${this.fieldModel.maxLength}`
        })
        onZoneChanges({
            fieldModel: {
                userResponse: () =>{
                    this.updateTextCounter()
                }
            }
        })
    }

    onZoneReady() {
       
    }

    template() {
        return template;
    }

    updateTextCounter(e) {
        this.props.textCounter = `${this.getCounter()} / ${this.fieldModel.maxLength}`;
        this.doValidate();
    }

    /**
     * @returns {number}
     */
    getCounter() {
        const { count_rule } = this.fieldModel.extends;
        return counterType[count_rule]?.call(null, this.getValue()) || this.getValue().length;
    }

    getValue() {
        return this.fieldModel.userResponse;
    }
}

export default MultipleTextWidget;